import React from 'react';
import './MainPage.css'

function MainPage() {
  return (
    <div className="mainPageAbout" id="about">
        <p>Twice as Bright Games is an independent game studio based out of Los Angeles, California. 
            We specialize in story-rich visual novels and skill-builder role-playing games set in immersive fantasy worlds. </p>
        
        <p>Our debut game, Conduit of the Miracle: Part One, is set to release for free download in early 2024. </p>
    </div>

  );
}

export default MainPage;
